import FilterChip from 'LuxKit/Chips/FilterChip'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import type { Form } from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/CruiseSearchChips'
import ModalContext from 'contexts/ModalContext'
import ModalCruiseSearchCruiseTypeChip from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/Modal/ModalCruiseSearchCruiseTypeChip'

export interface CruiseSearchCruiseTypeChipProps {
  facets: App.CruiseSearchFacetsV2
  filters: {
    cruiseTypes?: Set<string>
  }
  filterForm: Form
  setFilterForm: (form: Form) => void
  fetching?: boolean
  drawerMode?: boolean
}

function CruiseSearchCruiseTypeChip(props: CruiseSearchCruiseTypeChipProps) {
  const { filters, facets, filterForm, setFilterForm, fetching, drawerMode } = props
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const openModal = useCallback(async() => {
    await showModal<number>(<ModalCruiseSearchCruiseTypeChip
      drawerMode={drawerMode}
      facets={facets}
      filterForm={filterForm}
      filters={filters}
      setFilterForm={setFilterForm}
      fetching={fetching}
    />)
  }, [drawerMode, facets, fetching, filterForm, filters, setFilterForm, showModal])

  const countSelected = useMemo(() => {
    return (filters.cruiseTypes?.size || 0)
  }, [filters.cruiseTypes?.size])

  const hasCruiseTypes = useMemo(() => {
    return facets.cruiseTypes.some(facet => facet.count > 0)
  }, [facets.cruiseTypes])

  const chipLabel = countSelected ?
      intl.formatMessage(
        {
          id: '0ORNM-CUXO1g4g2io0Z9',
          defaultMessage: 'Cruise Type ({count})',
          description: 'Filter chip label for cruise type with selected filter count',
        },
        { count: countSelected },
      ) :
      intl.formatMessage({
        id: 'L4JFcJrARug80tcpAJXE',
        defaultMessage: 'Cruise Type',
        description: 'Filter chip label for cruise type when no filters are selected',
      })

  if (!hasCruiseTypes) {
    return null
  }

  return <FilterChip
    selected={!!filters.cruiseTypes && filters.cruiseTypes.size > 0}
    size="medium"
    onClick={openModal}
    endIcon={<LineAngleDownIcon />}
  >
    {chipLabel}
  </FilterChip>
}

export default CruiseSearchCruiseTypeChip
